// queries/dashboardQuery.js
import { gql } from 'graphql-tag';

export const GET_DASHBOARD_AGGREGATE = gql`
  query DashboardData {

   dashboard_training_per_day(where: {month_date: {_gte: "2024-07-01"}}) {
    month_date
    total: count
  }

    dashboard_accident_per_period {
    no_students_on_bus
    period_id
    students_on_bus
  }

  

  

      dashboard_accident_per_status {
      education_zone_id
      total
      vendor_id
      workflow_subcategory
    }

      dashboard_traning_per_status {
      education_zone_id
      total
      vendor_id
      workflow_subcategory
    }

         dashboard_survey_per_status {
      education_zone_id
      total
      vendor_id
      workflow_subcategory
    }


    


    traning_courses: training_courses_aggregate {
      aggregate {
        count
      }
    }
    traning_drivers: training_history_aggregate(
      distinct_on: nid
      where: { is_attend: { _eq: "حاضر" }, pass_status: { _eq: "ناجح" } }
    ) {
      aggregate {
        count
      }
    }
    pending_survey: daily_survey_aggregate(
      where: { workflow_subcategory: { _eq: 1 } }
    ) {
      aggregate {
        count
      }
    }
    done_survey: daily_survey_aggregate(
      where: { workflow_subcategory: { _in: [2, 3] } }
    ) {
      aggregate {
        count
      }
    }
    accidents_without_students: accidents_accident_log_aggregate(
      where: { students_on_bus: { _eq: 0 } }
    ) {
      aggregate {
        count
      }
    }
    accidents_with_students: accidents_accident_log_aggregate(
      where: { students_on_bus: { _gt: 0 } }
    ) {
      aggregate {
        count
      }
    }
  }
`;
